import { render } from "preact";
import "./style/index.css";
import App from "./components/app";
import { logToSentry } from "./services/logToSentry";

window.onerror = (message, url, line, column, error) =>
  logToSentry(error as Error);

render(<App />, document.getElementById("app") as HTMLElement);
